// Schedule types
export enum SCHEDULE_TYPE {
  HeatingSchedule = 'heatingSchedule',
  DhwSchedule = 'dhwSchedule',
  DhwCirculationSchedule = 'dhwCirculationSchedule',
  RoomSchedule = 'roomSchedule',
  VentilationSchedule = 'ventilationSchedule',
  NoiseReductionSchedule = 'noiseReductionSchedule',
  HybridPro = 'hybridPro',
}

// Schedule levels
export enum HEATING_SCHEDULE_LEVEL {
  Standby = 'standby', // Heating not active.
  Reduced = 'reduced', // Reduced heating temperature, selected in order to safe energy (eco mode, holiday mode etc).
  Normal = 'normal', // Default heating temperature when users are in home.
  /**
   * Heat pump related heating temperature. When the operating is heating, then heat ups to the maximum
   * flow temperature, when the operating mode is cooling, then cools down to the minimum flow temperature.
   */
  Fixed = 'fixed',
  Comfort = 'comfort', // E3 platform additional temperature level when users want to feel comfortable.
}

export enum DHW_SCHEDULE_LEVEL {
  Off = 'off', // Domestic hot water must not heat up according the schedule.
  On = 'on', // Domestic hot water should heat up according the schedule.
  Standby = 'standby', // Domestic hot water must not heat up according the schedule.
  Top = 'top', // Heat pump related dhw temperature.
  Normal = 'normal', // Domestic hot water should heat up according the schedule.
  Temp2 = 'temp-2', // Heat pump related dhw temperature.
}

export enum DHW_CIRCULATION_SCHEDULE_LEVEL {
  Off = 'off', // Domestic hot water circulation pump turned off.
  On = 'on', // Domestic hot water circulation pump turned on.
  On5minEvery10min = '5/10-cycles', // Domestic hot water circulation pump turned on for 5 minutes, repeated every 10 minutes.
  On5minEvery25min = '5/25-cycles', // Domestic hot water circulation pump turned on for 5 minutes, repeated every 25 minutes.
}

export enum NOISE_REDUCTION_SCHEDULE_LEVEL {
  NotReduced = 'notReduced',
  ReducedSlightly = 'reducedSlightly',
  MaxReduced = 'maxReduced',
}

export enum ROOM_SCHEDULE_LEVEL {
  Standby = 'standby', // Heating not active.
  Reduced = 'reduced', // Reduced heating temperature, can be selected in order to safe energy.
  Normal = 'normal', // Default heating temperature when users are in home.
  Comfort = 'comfort', // Increased (comfort) heating temperature, can be selected in order to increase comfort.
}

export enum HYBRID_PRO_SCHEDULE_LEVEL {
  Low = 'low',
  Normal = 'normal',
}
export enum VENTILATION_SCHEDULE_LEVEL {
  /**
   * Lowest levels of ventilation. Corresponding with level 1.
   */
  Basic = 'basic',
  LevelOne = 'levelOne',

  /**
   * Low levels of ventilation. Corresponding with level 2.
   */
  Reduced = 'reduced',
  LevelTwo = 'levelTwo',

  /**
   * Higher levels of ventilation. Corresponding with level 3.
   */
  Standard = 'standard',
  LevelThree = 'levelThree',

  /**
   * Highest levels of ventilation. Corresponding with level 4.
   */
  Intensive = 'intensive',
  LevelFour = 'levelFour',
}

export enum CONDITIONAL_OFF_PEAK_SIGNAL {
  SgReadyFeature = 'sgReadyFeature',
  ToggleSgReadyAndOffPeak = 'ToggleSgReadyAndOffPeak',
  PVSignalFeature = 'PVSignalFeature',
  TogglePVSignalAndOffPeak = 'TogglePVSignalAndOffPeak',
  OffPeakFeature = 'OffPeakFeature',
  NotVisible = 'NotVisible',
}

export enum INTERNAL_HYDRAULIC_SCHEDULE_LEVEL {
  Off = 'off',
  On = 'on',
}
